import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getReasonCode = (payload) => {
  return axios
    .get(`${URL_ORI}/api/ReasonCode/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createReasonCode = (payload) => {
  return axios.post(`${URL_ORI}/api/ReasonCode`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdReasonCode = (id) => {
  return axios
    .get(`${URL_ORI}/api/ReasonCode/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateReasonCode = (payload) => {
  return axios.put(`${URL_ORI}/api/ReasonCode`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteReasonCode = (payload) => {
  return axios.delete(`${URL_ORI}/api/ReasonCode`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// Master mater
export const getMasterUpload = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Miscellanous/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getIdMasterUpload = (id) => {
  return axios
    .get(`${URL_ORI}/api/Miscellanous/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createMasterUpload = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios
    .post(`${URL_ORI}/api/Miscellanous/upload?misc_file_type=${id}`, formData)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteMasterUpload = (payload) => {
  return axios.delete(`${URL_ORI}/api/Miscellanous`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateMasterUpload = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Miscellanous/process`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateMasterUploadCancel = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Miscellanous/cancel`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

